import { createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/2fa.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "modal-mask" }
const _hoisted_3 = { class: "modal-wrapper" }
const _hoisted_4 = {
  class: "modal-dialog modal-dialog-scrollable",
  role: "document"
}
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "col-1" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "col-10" }, [
  /*#__PURE__*/_createVNode("h5", { class: "card-title text-center text-dark" }, [
    /*#__PURE__*/_createVNode("b", null, "Two-Factor Authenticator")
  ])
], -1)
const _hoisted_10 = { class: "col-1" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_12 = { class: "container" }
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "two-factor authentication",
  class: "img-fluid"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-sm-12 mb-2 pt-1" }
const _hoisted_18 = { style: {"position":"relative"} }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", {
  class: "fas fas fa-paste",
  title: "Paste",
  style: {"position":"absolute","right":"9px","top":"10px"}
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-sm-12" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "row mt-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("a", {
        class: "btn btn-link",
        "data-toggle": "collapse",
        href: "#collapseHelp",
        role: "button",
        "aria-expanded": "false",
        "aria-controls": "collapseHelp"
      }, [
        /*#__PURE__*/_createVNode("span", { class: "mr-1" }, " I’m having trouble logging in "),
        /*#__PURE__*/_createVNode("i", { class: "fas fa-life-ring" })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", {
      class: "collapse",
      id: "collapseHelp"
    }, [
      /*#__PURE__*/_createVNode("div", { class: "card card-body" }, [
        /*#__PURE__*/_createVNode("h5", { class: "text-left font-weight-bold" }, " Fix common issues with 2-Step Verification "),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createVNode("p", { class: "text-left font-weight-bold" }, " Rescan the QR code "),
        /*#__PURE__*/_createVNode("p", { class: "text-left" }, [
          /*#__PURE__*/_createTextVNode(" Remove the current code holding the tap on yor Satstreet account and press the remove option "),
          /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" }),
          /*#__PURE__*/_createTextVNode(". Then rescan the QR code normally. ")
        ]),
        /*#__PURE__*/_createVNode("p", { class: "text-left font-weight-bold" }, " Set Automatic data and time. "),
        /*#__PURE__*/_createVNode("p", { class: "text-left" }, " In some cases our devices have the Date and Time manually configured, please use the automatic date and time provided by you network. To change that option got to the Settings panel of your device. "),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createVNode("small", { class: "text-muted" }, [
          /*#__PURE__*/_createTextVNode(" For more answers you can visit "),
          /*#__PURE__*/_createVNode("a", {
            href: "https://support.google.com/accounts/topic/2954345",
            target: "_blank",
            rel: "noopener noreferrer"
          }, " this site. "),
          /*#__PURE__*/_createTextVNode(" Please contact us by email at "),
          /*#__PURE__*/_createVNode("a", { href: "mailto:info@satstreet.com" }, " info@satstreet.com "),
          /*#__PURE__*/_createTextVNode(" if you have any questions. ")
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_Transition, { name: "modal" }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _hoisted_9,
                        _createVNode("div", _hoisted_10, [
                          _createVNode("button", {
                            type: "button",
                            class: "close",
                            "data-dismiss": "modal",
                            "aria-label": "Close",
                            onClick: _cache[1] || (_cache[1] = 
                        () => {
                          _ctx.$emit('close')
                          _ctx.code = ''
                        }
                      )
                          }, [
                            _hoisted_11
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _hoisted_14,
                        _createVNode("form", {
                          onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.verifyCode && _ctx.verifyCode(...args)), ["stop","prevent"]))
                        }, [
                          _hoisted_15,
                          _createVNode("div", _hoisted_16, [
                            _createVNode("div", _hoisted_17, [
                              _createVNode("div", _hoisted_18, [
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  maxlength: "6",
                                  onKeypress: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filterKeyPress && _ctx.filterKeyPress(...args))),
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.code = $event)),
                                  placeholder: "Enter the code",
                                  class: "form-control",
                                  autofocus: "",
                                  onKeydown: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.verifyCode && _ctx.verifyCode(...args)), ["enter"])),
                                  onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.autoSend && _ctx.autoSend(...args)))
                                }, null, 544), [
                                  [_vModelText, _ctx.code]
                                ]),
                                _createVNode("span", {
                                  class: "text-primary pointer",
                                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.setTextFromClipBoard && _ctx.setTextFromClipBoard(...args)))
                                }, [
                                  _hoisted_19
                                ])
                              ])
                            ])
                          ]),
                          _hoisted_20,
                          _createVNode("div", _hoisted_21, [
                            _createVNode("div", _hoisted_22, [
                              _createVNode("button", {
                                type: "submit",
                                class: "btn btn-block btn-primary",
                                disabled: _ctx.code.toString().length != 6 || _ctx.blockButton
                              }, " Verify ", 8, ["disabled"])
                            ])
                          ])
                        ], 32),
                        _hoisted_23
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}